// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"wrapper-p_Gme","content":"content-dXwWU"};